
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.014 18.094l8.028-7.912a1.503 1.503 0 012.11 0c.58.572.587 1.507.015 2.088l-8.031 7.916-2.122 2.1-2.13-2.092-8.049-7.94a1.48 1.48 0 01-.015-2.093 1.51 1.51 0 012.13-.015l8.064 7.948z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    